<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      initQ:''
    };
  },
  created() {
    let _this = this;
    _this.initQ = JSON.parse(JSON.stringify(_this.$route.query));
  },
  mounted(){
    let _this = this;
    let timer = null;
    let count = 0;

    let deviceId;
    let accountId;
    let sessionId;
    function doCPaction() {
      if (typeof(CP) == 'object' && CP._options.is_ready) {
        clearTimeout(timer);
        CP.get_device_info(function (data) {
            deviceId = data.device_no || -1;
            CP.tools.writelog('get_device_info', data);
        }, true, {
            cp_incompatible: function () {
                deviceId =-1;
                CP.tools.writelog('', '此环境不支持get_device_info方法');
            }
        });
        CP.get_unique_id(function (data) {
          sessionId = data.unique_id;
        }, true, {
          cp_incompatible: function () {
            sessionId =-1;
            CP.tools.writelog('', '此环境不支持此方法');
          }
        });
        CP.get_client_info(function (data) {
          _this.clinet_info = data;
          if (data.client_code=='zjxw'||data.client_code=='h24') {
            CP.is_login(function (data) {
              if (data.is_login==='1') {
                CP.get_account_id(function (data) {
                  accountId = data.account_id;
                });
              }else{
                accountId=-1;
              }
            });
          }else{
              accountId=-1;
          }
        });
        _this.udcAjax({accountId,sessionId,deviceId});
      } else {
        count++;
        if (count > 10) {
          return ;
        }
        timer = setTimeout(doCPaction, 200);
      }
    }
    timer = setTimeout(doCPaction, 200);
  },
  methods: {
      udcAjax(option) {
        let _this = this;
        let initFace = Object.assign({},_this.initQ,option);
        const type = location.pathname.split('/')[1];
        _this.Get({
          url:'/activity/api.php?m=public&subm=actstatistics',
          data:{...initFace, type},
          success: function(data) {
            let resdata = data.data;
            const activityInfo = {
              ...option,
              ...resdata
            }
            window.udc.updateActivity(activityInfo);
            window.udc.pageview();
            window.udc.udcClick(['.news-click|click']);
          }
        });
      }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  /*overflow-y: auto;
  height: 100%;*/
  overflow-x: hidden;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue